import { Typography } from '@mui/material';
import { TransactionStatus } from '@/models/transaction';
import { FONT_WEIGHT, TEXT_SIZE } from '@/typography/Typography';
import Chip from '@/components/shared/Chip';
import { TipsStatus } from '@/services/PaymentsServiceV2';

const getStatusColor = (status: TransactionStatus | TipsStatus) => {
    switch (status) {
        case TransactionStatus.PendingApproval:
            return 'info';
        case TransactionStatus.AwaitingBank:
        case TransactionStatus.AwaitingDeposit:
        case TransactionStatus.ActionInProgress:
        case TransactionStatus.Authorized:
            return 'warning';
        case TransactionStatus.Succeeded:
            return 'success';
        case TransactionStatus.Failed:
            return 'error';
        case TransactionStatus.Rejected:
            return 'error';
        case TransactionStatus.Expired:
            return 'error';
        case TipsStatus.Succeeded:
            return 'success';
        case TipsStatus.Awaiting:
            return 'warning';
        default:
            return 'info';
    }
};

export const HistoryStatus = <T extends TransactionStatus | TipsStatus>({
    status,
    showDot
}: {
    status: T;
    showDot?: boolean;
}) => {
    return (
        <Chip
            color={getStatusColor(status) as any}
            icon={!showDot ? <span></span> : undefined}
            label={
                <Typography
                    fontWeight={FONT_WEIGHT.MEDIUM}
                    fontSize={TEXT_SIZE.SMALL}
                >
                    {TransactionStatus[status as TransactionStatus] ??
                        TipsStatus[status as TipsStatus]}
                </Typography>
            }
        />
    );
};
